import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CellComponent } from '@shared/components/cell-components/cell-component';
import { FieldDefinition } from '@shared/models/field-definition';
import { CommandService } from '@core/services/command.service';
import { ShareItemsComponent } from '@shared/components/share-items/share-items.component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { AddMemberToItemCommand } from '../../../commands/create-directory.command';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {FileManagerService} from "../../../services/file-manager.service";
import {take} from "rxjs/operators";

@Component({
    standalone: false,
    selector: 'particle-shared-drive-members-cell-viewer',
  templateUrl: './shared-drive-members-cell-viewer.component.html',
  styleUrls: ['./shared-drive-members-cell-viewer.component.scss']
})
export class SharedDriveMembersCellViewerComponent implements OnInit, CellComponent {
  valueChanged?: EventEmitter<any>
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  invalidateSubject: InvalidateSubject;
  defualtBoardPermisssion = {
    'title': 'No Access',
    'description': 'Cannot access any ticket(s)',
    'permissionType': 0
  }
  disabled: boolean;
  constructor(protected dialog: MatDialog,
              protected commandService: CommandService,
              protected shareItemService: ShareItemService,
              private fileManagerService: FileManagerService) { }

  ngOnInit() {
    if(!this.invalidateSubject)this.invalidateSubject = new InvalidateSubject();
  }

  openManageMembersDialog() {
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'DriveMembersKey';
    model.itemId = this.item.id;
    model.metaData = {
      'DriveName': this.item.cells.Name.value
    };
    this.fileManagerService.getSharedMembersByDriveId(this.item.id).pipe( take(2) ).subscribe(item=>{
      if(item){
        const selectedUsers = this.shareItemService.mapSelectedUsers(item.userGroups);
        const contactsMetaData={
          'selectedUsers': selectedUsers,
          'permissions': item.permissions,
          'defaultPermission': this.defualtBoardPermisssion
        };
        const command = new AddMemberToItemCommand('', this.item.id, [], model.metaData);
        this.shareItemService.showDialog(model, contactsMetaData, command);
      }
    })

    // return;
    // const dialogRef = this.dialog.open(ShareItemsComponent, {
    //   minWidth: '400px',
    //   maxWidth: '530px',
    //   data: {
    //     queryKey: 'DriveMembersKey',
    //     itemId: this.item.id
    //   }
    // });
    //
    // dialogRef.afterClosed().pipe().subscribe((result: any) => {
    //   console.log(result);
    //   if (result.selection && result.selection.length) {
    //     const command = new AddMemberToItemCommand(result.itemId, result.selection);
    //
    //     this.commandService.executeCommand(command).pipe().subscribe(data => {
    //       console.log('AddMemberToDriveCommand finished');
    //       this.invalidateSubject.invalidate();
    //     });
    //   }
    // });
  }


}
